<ng-container *transloco="let tr; prefix: 'brands'; scope: 'brands'">
  <form nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()">
    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.country')}}</nz-form-label>
          <nz-form-control>
            <hx-country-select formControlName="countryId"
                               (selectChange)="onCountryChanged($event)"></hx-country-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.title')}}</nz-form-label>
          <nz-form-control>
            <hx-label-edit formControlName="title"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-alert *ngIf="!brandTitleId" nzType="info" [nzMessage]="tr('files.notification.enabledAfterSaving')"
              nzShowIcon></nz-alert>

    <ng-container *ngIf="brandTitleId">
      <nz-divider nzDashed="true" [nzText]="tr('files.attachments')" nzOrientation="left"></nz-divider>
      <div nz-row [nzGutter]="8" class="files-container">
        <div nz-col [nzSpan]="24">
          <nz-skeleton [nzActive]="true" *ngIf="isLoading.files"></nz-skeleton>
          <div class="clearfix" *ngIf="!isLoading.files">
            <nz-upload
              nzListType="picture"
              class="upload-list-inline"
              [(nzFileList)]="fileList"
              [nzAction]="filesUploadUrl"
              [nzMultiple]="false"
              [nzRemove]="fileRemoveFn"
              [nzHeaders]="fileUploadHeadersFn"
              (nzChange)="handleFileUploadStatusChanged($event, 'files')"
              [nzPreview]="handlePreviewFn"
              [nzBeforeUpload]="beforeUploadFn">
              <button type="button" nz-button>
                <span><i nz-icon nzType="upload"></i> {{'button.upload' | transloco}}</span>
              </button>
            </nz-upload>
            <nz-modal [nzVisible]="preview.visible" [nzTitle]="preview.fileName" [nzWidth]="'initial'"
                      [nzContent]="modalContent" [nzFooter]="null" (nzOnCancel)="preview = {}">
              <ng-template #modalContent>
                <div nz-row>
                  <nz-col [nzSpan]="24">
                    <input nz-input type="text" readonly [value]="preview.link">
                  </nz-col>
                </div>
                <nz-divider></nz-divider>
                <div nz-row *ngIf="preview.fileName">
                  <div *ngIf="!preview.fileName.endsWith('.md')" nz-col [nzSpan]="24" style="text-align: center">
                    <img [src]="preview.image"/>
                  </div>
                  <div *ngIf="preview.fileName.endsWith('.md') && preview.data" nz-col [nzSpan]="24">
                    <markdown [data]="preview.data"></markdown>
                  </div>
                </div>
              </ng-template>
            </nz-modal>
          </div>
        </div>
      </div>

      <div nz-row [nzGutter]="8" class="files-flag-container m--margin-top-20">
        <div nz-col [nzSpan]="24">
          <nz-tag *ngFor="let rf of requiredFiles" [nzColor]="rf.exist ? 'success': 'warning'">
            <i nz-icon [nzType]="rf.exist ? 'check-circle' : 'exclamation-circle'"></i>
            <span>{{rf.fileName}}({{rf.size}}).{{rf.format}}</span>
          </nz-tag>
        </div>
      </div>
    </ng-container>

    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco"
              nzShowIcon></nz-alert>
  </form>
</ng-container>

<div *nzModalFooter>
  <button (click)="modalRef.close()" nz-button nzType="default">{{ 'button.cancel' | transloco }}</button>
  <button [disabled]="form.pristine || isLoading.save || form.invalid" [nzLoading]="isLoading.save" (click)="submitForm()" nz-button nzType="primary">{{ 'button.save' | transloco }}</button>
</div>

